import React, { Component } from 'react'
import './Trends.css'

class Trends extends Component {
  constructor(props) {
    super(props)

    this.state = {
      img: ""
    }

  }
  componentDidMount() {
    setTimeout(() => {
      var TredsDeatils = JSON.parse(sessionStorage.selectedSiteData)['PowerBIURL']
      if (!TredsDeatils) {
        this.props.history.push('/login');
      }
      else {
        this.setState({
          img: TredsDeatils
        })
      }
    }, 1000)
  }
  render() {
    return (
      <div>
        <div className="card  custcard">
          <div className="cord-body">
            <div className="testHeading">
              <label className="headermsg1" id="TestResult">Trends</label>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body iframe-hold">
            <iframe src={this.state.img} title="trends" className="trends"></iframe>
          </div>
        </div>
      </div>
    )
  }
}

export default Trends
